'use client';

import { FC, PropsWithChildren } from 'react';
import { IntersectionObserverHandler } from 'src/general/components/IntersectionObserverHandler/IntersectionObserverHandler';
import { pushToDataLayer } from 'src/utils/pushToDataLayer';

export const CarSpecsAndFeatures: FC<PropsWithChildren> = ({ children }) => (
  <IntersectionObserverHandler
    margins="-50%"
    onIntersecting={() => {
      pushToDataLayer({
        event: 'pdp_interaction',
        type: 'scroll',
        value: 'specs_and_features',
      });
    }}
  >
    {children}
  </IntersectionObserverHandler>
);
